import { Component, OnInit } from '@angular/core';
import { ResumeService } from 'src/app/modules/dashboard/services/resume.service';

@Component({
  selector: 'alert-time-response-resolution',
  templateUrl: './alert-time-response-resolution.component.html',
  styleUrls: ['./alert-time-response-resolution.component.scss'],
})
export class AlertTimeResponseResolutionComponent implements OnInit {
  constructor(public resumeService: ResumeService) {}

  ngOnInit() {
    this.getAverageResponseTime();
    this.getAverageResolutionTime();
  }
  currentMonthAverageResponse;
  previousMonthAverageResponse;
  async getAverageResponseTime() {
    await this.resumeService.getAverageResponseTime().subscribe((res: any) => {
      // Piso 0, igual que resolución: nunca horas negativas ni NaN
      this.currentMonthAverageResponse = Math.max(0, res.currentMonthAverage || 0);
      this.previousMonthAverageResponse = Math.max(0, res.previousMonthAverage || 0);
    });
  }
  currentMonthAverageResolution;
  previousMonthAverageResolution;
  async getAverageResolutionTime() {
    await this.resumeService
      .getAverageResolutionTime()
      .subscribe((res: any) => {
        // Piso 0: nunca horas negativas ni NaN
        this.currentMonthAverageResolution = Math.max(
          0,
          res.currentMonthAverage || 0
        );
        this.previousMonthAverageResolution = Math.max(
          0,
          res.previousMonthAverage || 0
        );
      });
  }
}
